<template>
    <div class="modal fade confirmation-modal" :id=ModalId tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">

            <div class="modal-content">
                <div class="modal-header p-0" v-if="Title">
                    <h3 class="section-title m-4">{{ Title }}</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>

                <button v-else type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times"></i>
                </button>
                <div class="modal-body">
                    <p v-bind:class="{ 'mt-3': Title}">{{ Message }}</p>
                    <a class="ink-button min-width" href="#" v-on:click="OnClick_Cancel" data-dismiss="modal">{{ CancelText }}</a>
                    <a class="ink-button main-action min-width" href="#" v-on:click="OnClick_OK" data-dismiss="modal">{{ OkText }}</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        ModalId: {
            type: String,
            default: "ConfirmationModal"
        },
        Title: {
            type: String,
        },
        Message: {
            type: String,
            default: "Tem a certeza de que pretende limpar a pesquisa?"
        },
        OkText: {
            type: String,
            default: "OK"
        },
        CancelText: {
            type: String,
            default: "Cancelar"
        }
    },
    methods: {
        async OnClick_OK() {
            this.$emit("OnOk");
            this.$emit("on-ok");
        },
        async OnClick_Cancel() {
            this.$emit("on-cancel");
        }
    }
};
</script>